import { createSelector, Selector } from 'reselect';
import publicRoutes from '../../../routes/publicRoutes';
import { selectPath } from './getPath.selector';
import { State } from '../../../store/reducers';

export const selectIsLoginRoute: Selector<State, boolean> = createSelector(
  [selectPath],
  (path) => path === publicRoutes.Login.path
);
